<template>
    <div class="media">
        <template v-if="configuration.contentType === 'video'">
                <video
                    controls
                    crossorigin="anonymous"
                    controlsList="nodownload"
                    @contextmenu.prevent
                    @mousedown.right.prevent
                    preload="metadata"
                >
                <source :src="configuration.metadata.url" type="video/mp4" />
            </video>
        </template>
        <template v-else-if="configuration.contentType === 'image'">
            <img :src="attachment.metadata.url" v-for="attachment of configuration.attachments" :key="attachment.id" class="block" />
        </template>
        <template v-else-if="configuration.contentType === 'embed'">
            <div class="aspect-ratio" v-for="embed of configuration.attachments" :key="embed.id" :style="{paddingBottom: `${100 / embed.metadata.aspect}%`}">
                <div class="embedded-item" v-html="embed.metadata.code"></div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'Media',
        props: {
            configuration: Object
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .media
    {
        max-width: 800px;
        width: 100%;

        video
        {
            max-width: 800px;
            width: 100%;
            box-shadow: 0 6px 30px -2px rgba(0, 0, 0, 0.35);
            border-radius: 6px;
            margin-top: 40px;
        }

        img
        {
            margin: 0 auto;
            margin-top: 30px;
            max-width: 100%;
        }

        .aspect-ratio
        {
            margin-top: 30px;
        }

        .embedded-item
        {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
        }
    }
</style>
